{/* 
    O componente CampoTexto recebe várias props:
    - label: o texto que será exibido como rótulo do campo
    - labelClass: a classe CSS para o rótulo
    - class: a classe CSS para o campo de entrada
    - wrapperClass: a classe CSS para o container do campo
    - tipo: o tipo de entrada (por exemplo, "text", "password, " "email", etc.)
    - placeholder: o texto de espaço reservado no campo
    - obrigatorio: indica se o campo é obrigatório (true ou false)
    - tamanhoMaximo: o tamanho máximo permitido para o valor do campo
    - nome: o nome do campo
    - id: o ID do campo
    - valor: o valor atual do campo
    - aoDigitado: função chamada quando o usuário digita algo no campo
    - onChange: função chamada quando o valor do campo muda
*/}
const CampoTexto = ({label, labelClass, className, wrapperClass, tipo, placeholder, obrigatorio, editavel, tamanhoMaximo, nome, id, valor, aoDigitado, onChange}) => {

    /*  Função que será chamada quando o usuário digitar algo no campo de texto
        Ela recebe o evento de mudança (evento) e chama a função aoDigitado
        passando o valor atual do campo de texto (evento.target.value)
        Isso permite que o componente pai receba o valor digitado pelo usuário
        e atualize o estado correspondente
        O evento.target.value contém o valor atual do campo de texto
        aoDigitado é uma constante que executa uma arrow function que retorna o valor que foi digitado no campo texto para a prop aoDigitado do componente pai
    */
    const aoDigitarValor = (evento) => {
        // Se for um input de arquivo e existir a prop onChange, usa ela
        if (tipo === 'file' && onChange) {
            onChange(evento);
        } else {
            // Se existir a prop aoDigitado (para textos), usa ela
            aoDigitado(evento.target.value);
        }
    }

    return (
        <div className={wrapperClass}>
            <label className={labelClass} htmlFor={id}>{label}</label>
            <input 
                className={className}
                type={tipo} 
                placeholder={placeholder} 
                required={obrigatorio} 
                readOnly={!editavel}
                maxLength={tamanhoMaximo} 
                name={nome} 
                id={id} 
                // Input de arquivo NÃO pode ter a prop value (gera erro no React)
                value={tipo !== 'file' ? valor : undefined}
                onChange={aoDigitarValor}
                accept={tipo === 'file' ? ".jpg, .jpeg, .png" : undefined}
                
            />
        </div>    
    );
}

export default CampoTexto;